export default [
  {
    path: '/account-balance/:key?',
    name: 'accountbalance',
    component: () => import('@/views/initialBalance/accountBalance/index.vue'),
    meta: {},
  },
];
